import { ArrowUpFromLine, CheckCheck, Reply, Send, Star, Trash2, X, File } from 'lucide-react';
import React, { Fragment, memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'
import VideoPlayer from '../components/VideoPlayer';
import AudioPlayer from '../components/AudioPlayer';
import LinkHighlighter from '../components/LinkHighlighter';
import BeautifiedCodeViewer from '../components/BeautifiedCodeViewer';
import MapCard from '../components/MapCard';

function UserChat(props) {
    const {
        chatMessages,
        highlightReply,
        senderContainerColor,
        receiverContainerColor,
        senderTextColor,
        receiverTextColor,
        messagesContainerRef,
        scrollToMessage,
        authUserId,
        checkFileType,
        openInNewTab,
        formatFile,
        handleReplyMessage,
        isProbablyCode,
        handleDeleteMessage,
        senderDateTextColor,
        receiverDateTextColor,
        color,
        senderLinkTextColor,
        receiverLinkTextColor,
        replyMessageData,
        sendButtonColor,
        setReplyMessageData,
        fetchChatHistory,
        activeUserChat,
        chatPageLimit,
        hasMoreMessagesRef,
        ctaButtonColor, ctaButtonText,
        handleAkcBroadcast
    } = props;

    const divRef = useRef();
    const [page, setPage] = useState(1);
    const pageSize = 10;
    const [prevScrollHeight, setPrevScrollHeight] = useState(null);
    const [isLoadings, setIsLoading] = useState(false);
    const isFetchingRef = useRef(false);
    const scrollTimeoutRef = useRef(null);

    // Memoize flattened and sorted chats
    const allChats = useMemo(() => {
        if (!Array.isArray(chatMessages)) return [];
        return chatMessages
            .flatMap(day => day)
            .sort((a, b) => new Date(b.date) - new Date(a.date));
    }, [chatMessages]);

    // Memoize visible chats
    const visibleChats = useMemo(() => {
        return allChats.slice(0, page * pageSize);
    }, [allChats, page]);

    // ✅ Fixed scroll handler with proper debouncing and bottom detection

    // const handleScroll = useCallback(() => {
    //     const el = divRef.current;

    //     // ✅ Add hasMoreMessages check
    //     if (!el || isLoadings || isFetchingRef.current || !hasMoreMessagesRef.current) {
    //         return;
    //     }

    //     if (scrollTimeoutRef.current !== null) {
    //         clearTimeout(scrollTimeoutRef.current);
    //         scrollTimeoutRef.current = null;
    //     }

    //     scrollTimeoutRef.current = setTimeout(() => {
    //         const scrollTop = Math.abs(el.scrollTop);
    //         const scrollHeight = el.scrollHeight;
    //         const clientHeight = el.clientHeight;
    //         const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

    //         console.log('Scroll Debug:', {
    //             scrollTop,
    //             scrollHeight,
    //             clientHeight,
    //             distanceFromBottom,
    //             isAtBottom: distanceFromBottom <= 50,
    //             hasMoreMessages: hasMoreMessagesRef.current
    //         });

    //         if (distanceFromBottom <= 50 && !isFetchingRef.current && hasMoreMessagesRef.current) {
    //             console.log('📥 Fetching more messages...');

    //             const currentScrollHeight = el.scrollHeight;

    //             setIsLoading(true);
    //             isFetchingRef.current = true;
    //             setPrevScrollHeight(currentScrollHeight);

    //             // For UserChat
    //             fetchChatHistory(activeUserChat._id, chatPageLimit)
    //                 .catch(error => {
    //                     console.error('Error fetching chat history:', error);
    //                 })
    //                 .finally(() => {
    //                     setTimeout(() => {
    //                         setIsLoading(false);
    //                         isFetchingRef.current = false;
    //                     }, 300);
    //                 });


    //         }

    //         scrollTimeoutRef.current = null;
    //     }, 150);
    // }, [isLoadings, fetchChatHistory, activeUserChat, chatPageLimit, hasMoreMessagesRef]);



    // // const handleScroll = () => {
    // //     const el = divRef.current;
    // //     if (!el || isLoadings) return; // Prevent multiple calls when loading

    // //     console.log('el.scrollTop + el.clientHeight', Math.round(-el.scrollTop + el.clientHeight), el.scrollHeight);

    // //     // ✅ proper bottom detection
    // //     if (-el.scrollTop + el.clientHeight + 2 >= el.scrollHeight - 5) {
    // //         const prevScrollHeight = el.scrollHeight;
    // //         console.log('prevScrollHeight', prevScrollHeight);
    // //         setIsLoading(true); // Set loading to true
    // //         setPrevScrollHeight(prevScrollHeight);
    // //         // setPage((p) => p + 1);
    // //         fetchChatHistory(activeUserChat._id, chatPageLimit)
    // //             .catch(error => {
    // //                 console.error('Error fetching chat history:', error);
    // //             })
    // //             .finally(() => {
    // //                 setTimeout(() => {
    // //                     setIsLoading(false);
    // //                     isFetchingRef.current = false;
    // //                 }, 300);
    // //             });

    // //     }
    // // };
    // // ✅ Maintain scroll position after loading new messages
    // useEffect(() => {
    //     if (prevScrollHeight === null) return;

    //     const el = divRef.current;
    //     if (!el) return;

    //     requestAnimationFrame(() => {
    //         const newScrollHeight = el.scrollHeight;
    //         const heightDifference = newScrollHeight - prevScrollHeight;

    //         // Adjust scroll position to maintain user's view
    //         el.scrollTop -= heightDifference;

    //         console.log('📍 Scroll adjusted:', {
    //             prevHeight: prevScrollHeight,
    //             newHeight: newScrollHeight,
    //             difference: heightDifference
    //         });

    //         setPrevScrollHeight(null);
    //     });
    // }, [chatMessages, prevScrollHeight]);

    // // ✅ Reset loading state when new messages arrive
    // useEffect(() => {
    //     if (isFetchingRef.current && !isLoadings) {
    //         isFetchingRef.current = false;
    //     }
    // }, [chatMessages, isLoadings]);

    // // ✅ Cleanup timeout on unmount
    // useEffect(() => {
    //     return () => {
    //         if (scrollTimeoutRef.current !== null) {
    //             clearTimeout(scrollTimeoutRef.current);
    //             scrollTimeoutRef.current = null;
    //         }
    //     };
    // }, []);
    const handleScroll = useCallback(() => {
        const el = divRef.current;

        // Prevent execution if element doesn't exist or already loading
        if (!el || isLoadings || isFetchingRef.current || !hasMoreMessagesRef.current) return;

        // Clear existing timeout
        if (scrollTimeoutRef.current !== null) {
            clearTimeout(scrollTimeoutRef.current);
            scrollTimeoutRef.current = null;
        }

        // Debounce scroll handler
        scrollTimeoutRef.current = setTimeout(() => {
            const scrollTop = Math.abs(el.scrollTop); // Handle negative scrollTop
            const scrollHeight = el.scrollHeight;
            const clientHeight = el.clientHeight;

            // Calculate distance from bottom (with 50px threshold)
            const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

            console.log('Scroll Debug:', {
                scrollTop,
                scrollHeight,
                clientHeight,
                distanceFromBottom,
                isAtBottom: distanceFromBottom <= 50
            });

            // ✅ Check if scrolled near bottom
            if (distanceFromBottom <= 50 && !isFetchingRef.current && hasMoreMessagesRef.current) {
                console.log('📥 Fetching more messages...');

                const currentScrollHeight = el.scrollHeight;

                // Set loading states
                setIsLoading(true);
                isFetchingRef.current = true;
                setPrevScrollHeight(currentScrollHeight);

                // Fetch chat history
                fetchChatHistory(activeUserChat._id, chatPageLimit)
                    .catch(error => {
                        console.error('Error fetching chat history:', error);
                    })
                    .finally(() => {
                        // Reset loading state after a short delay
                        setTimeout(() => {
                            setIsLoading(false);
                            isFetchingRef.current = false;
                        }, 300);
                    });
            }

            scrollTimeoutRef.current = null;
        }, 150); // 150ms debounce
    }, [isLoadings, fetchChatHistory, activeUserChat, chatPageLimit, hasMoreMessagesRef]);

    // ✅ Maintain scroll position after loading new messages
    useEffect(() => {
        if (prevScrollHeight === null) return;

        const el = divRef.current;
        if (!el) return;

        requestAnimationFrame(() => {
            const newScrollHeight = el.scrollHeight;
            const heightDifference = newScrollHeight - prevScrollHeight;

            // Adjust scroll position to maintain user's view
            el.scrollTop -= heightDifference;

            console.log('📍 Scroll adjusted:', {
                prevHeight: prevScrollHeight,
                newHeight: newScrollHeight,
                difference: heightDifference
            });

            setPrevScrollHeight(null);
        });
    }, [chatMessages, prevScrollHeight]);

    // ✅ Reset loading state when new messages arrive
    useEffect(() => {
        if (isFetchingRef.current && !isLoadings) {
            isFetchingRef.current = false;
        }
    }, [chatMessages, isLoadings]);

    // ✅ Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (scrollTimeoutRef.current !== null) {
                clearTimeout(scrollTimeoutRef.current);
                scrollTimeoutRef.current = null;
            }
        };
    }, []);

    // Render reply preview
    const renderReplyPreview = useCallback((message) => {
        if (!message?.replyMessageId) return null;

        return (
            <div
                className={`p-2 rounded border-l-4 cursor-pointer shadow mb-2
                    ${message.isSent ? 'bg-gray-600 border-teal-600' : 'bg-gray-100 border-teal-600'}`}
                onClick={(e) => {
                    e.stopPropagation();
                    scrollToMessage(message.replyMessageId._id);
                }}
            >
                <div className={`text-xs font-medium mb-1 text-black ${message.sender === 'me' ? 'text-primary' : 'text-primary'
                    }`}>
                    {message?.replyMessageId?.fromUserId?._id === authUserId
                        ? "You"
                        : message?.replyMessageId?.fromUserId?.name || "Unknown User"
                    }
                </div>
                <div className="text-xs text-gray-700 truncate">
                    {message?.replyMessageId?.messageContent || "Message content unavailable"}
                </div>
            </div>
        );
    }, [authUserId, scrollToMessage]);

    // Render file preview
    const renderFilePreview = useCallback((message) => {
        const fileType = checkFileType(message.fileType);

        switch (fileType) {
            case 'image':
                return (
                    <div className="flex justify-center items-center mb-1">
                        <img
                            src={message.link}
                            alt="Preview"
                            className="max-h-32 rounded cursor-pointer"
                            onClick={() => openInNewTab(message.link)}
                            loading="lazy"
                        />
                    </div>
                );
            case 'video':
                return <VideoPlayer src={message.link} color={color} />;
            case 'audio':
                return <AudioPlayer src={message.link} color={color} />;
            case 'application':
                return (
                    <div
                        className="flex items-center bg-gray-200 p-2 rounded cursor-pointer mb-1"
                        onClick={() => openInNewTab(message.link)}
                    >
                        <File size={20} className="text-black mr-2" />
                        <p className="text-sm font-medium text-black truncate">
                            {/* Document{formatFile(message.link)} */}
                            {message?.fileName ? message?.fileName : <>Document{formatFile(message.link)}</>}
                        </p>
                    </div>
                );
            case 'text':
                return (
                    <div
                        className="flex items-center bg-gray-200 p-2 rounded cursor-pointer mb-1"
                        onClick={() => openInNewTab(message.link)}
                    >
                        <File size={20} className="text-black mr-2" />
                        <p className="text-sm font-medium text-black truncate">
                            {message?.fileName ? message?.fileName : <>Document{formatFile(message.link)}</>}
                            {/* {formatFile(message.link)} */}
                        </p>
                    </div>
                );
            default:
                return null;
        }
    }, [checkFileType, openInNewTab, formatFile, color]);

    // Render message actions
    const renderMessageActions = useCallback((message) => {
        if (message.isDeleted) return null;

        return (
            <div
                className={`absolute top-1/2 -translate-y-1/2 z-10 flex items-center gap-2 px-2
                    ${message.sender === 'me' ? 'right-full ml-2' : 'left-full mr-2'}
                    opacity-0 group-hover:opacity-100 transition-opacity`}
            >
                <Reply
                    onClick={() => handleReplyMessage(message)}
                    className="text-gray-400 hover:text-primary cursor-pointer"
                    size={18}
                />
                {message.sender === 'me' && (
                    <Trash2
                        onClick={() => handleDeleteMessage(message)}
                        className="text-gray-400 hover:text-primary cursor-pointer"
                        size={18}
                    />
                )}
            </div>
        );
    }, [handleReplyMessage, handleDeleteMessage]);

    // Render message content
    const renderMessageContent = useCallback((message) => {
        const isMe = message.sender === 'me';

        if (message.isDeleted) {
            return (
                <div
                    className={`p-2 text-xs italic rounded-xl shadow-md whitespace-pre-wrap break-words  
                        ${isMe ? 'rounded-br-none' : 'rounded-bl-none'}`}
                    style={{
                        backgroundColor: isMe ? senderContainerColor : receiverContainerColor,
                        color: isMe ? senderTextColor : receiverTextColor,
                    }}
                >
                    {isMe ? 'You deleted this message' : "This message was deleted"}
                </div>
            );
        }

        return (
            <div
                className={`p-2 rounded-xl shadow-md whitespace-pre-wrap break-words  
                    ${isMe ? 'rounded-br-none' : 'rounded-bl-none'}`}
                style={{
                    backgroundColor: isMe ? senderContainerColor : receiverContainerColor,
                    color: isMe ? senderTextColor : receiverTextColor,
                }}
            >
                {renderReplyPreview(message)}
                {renderFilePreview(message)}

                {message?.type === "L" && message?.text && (
                    <MapCard data={message?.text} />
                )}

                {/* TEXT / LINK / CODE */}
                {!isProbablyCode(message.text) &&
                    // checkFileType(message.fileType) !== 'image' &&
                    message.text !== '' &&
                    message.type !== 'L' &&
                    (
                        <div className="text-sm mt-1">
                            <LinkHighlighter
                                text={message?.text || ""}
                                color={isMe ? senderLinkTextColor : receiverLinkTextColor}
                            />
                        </div>
                    )}

                {isProbablyCode(message.text) && (
                    <BeautifiedCodeViewer code={message.text} />
                )}
                {message.sender !== 'me' && (message?.broadCastMessageId) &&
                    <button
                        disabled={message?.isBroadCastAcknowledge}

                        className={`px-4 py-2 w-full justify-center mt-2 text-xs rounded-md hover:bg-primary flex items-center disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer`}
                        style={{ backgroundColor: ctaButtonColor || "#000", color: ctaButtonText || "#fff" }}

                        onClick={() => handleAkcBroadcast(message._id)}
                    >

                        {message?.isBroadCastAcknowledge ? "Acknowledged" : "I Acknowledge"}
                    </button>

                }
            </div>
        );
    }, [senderContainerColor, receiverContainerColor, senderTextColor, receiverTextColor,
        renderReplyPreview, renderFilePreview, isProbablyCode, checkFileType,
        senderLinkTextColor, receiverLinkTextColor]);

    return (
        <Fragment>
            <div
                ref={divRef}
                onScroll={handleScroll}
                tabIndex={-1}
                className="flex-1 p-3 overflow-y-auto flex flex-col-reverse"
            >
                {/* ✅ Loading indicator */}
                {isLoadings && (
                    <div className="text-center py-3 text-gray-500 text-sm animate-pulse">
                        Loading more messages...
                    </div>
                )}

                {chatMessages.map((chat, chatIndex) => (
                    <div
                        ref={messagesContainerRef}
                        key={`chat-${chatIndex}-${chat?.date || chatIndex}`}
                    >
                        {/* Date Divider */}
                        <div className="text-xs bg-primary/20 text-primary px-2 py-1 mx-auto my-4 backdrop-blur-sm border-b w-fit rounded border-gray-400">
                            {chat?.date || 'Unknown Date'}
                        </div>

                        {Array.isArray(chat?.chats) && [...chat.chats].reverse().map((message, index) => {
                            if (!message) return null;

                            const isMe = message.sender === 'me';

                            return (
                                <div
                                    id={`message-${message._id}`}
                                    key={`message-${message._id || index}`}
                                    className={`mb-2 flex flex-col ${isMe ? 'items-end' : 'items-start'
                                        } ${highlightReply === message._id
                                            ? 'transition-colors duration-1000 bg-yellow-100 rounded-xl'
                                            : ""
                                        }`}
                                >
                                    <div className="relative group max-w-[75%]">
                                        {/* Message Bubble */}
                                        {renderMessageContent(message)}
                                        {renderMessageActions(message)}
                                    </div>

                                    {/* Timestamp & Read Receipt */}
                                    <div
                                        className={`text-xs mt-1 flex gap-1 items-center ${isMe ? 'justify-end text-gray-600' : 'justify-start text-gray-800'
                                            }`}
                                        style={{
                                            color: isMe ? senderDateTextColor : receiverDateTextColor,
                                        }}
                                    >
                                        {(isMe && message.isStared) && (
                                            <span>
                                                <Star fill='#eab308' className='text-yellow-500' size={10} />
                                            </span>
                                        )}
                                        <span>{message.time || 'Unknown time'}</span>
                                        {isMe && (
                                            <CheckCheck
                                                size={16}
                                                className={message.isRead ? 'text-blue-500' : 'text-gray-400'}
                                            />
                                        )}
                                        {(!isMe && message.isStared) && (
                                            <span>
                                                <Star fill='#eab308' className='text-yellow-500' size={10} />
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>

            {/* Reply Preview */}
            {replyMessageData && (
                <div className="px-4 py-2 bg-gray-100 border-b border-gray-200 flex items-start sm:items-center">
                    <div
                        className="w-1 h-12 rounded-full mr-3 flex-shrink-0"
                        style={{ backgroundColor: sendButtonColor || "#000" }}
                    />

                    <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between gap-2">
                            <span className="text-xs font-medium text-gray-600 whitespace-nowrap">
                                Replying to{' '}
                                {replyMessageData.sender === "reciver"
                                    ? replyMessageData?.user?.name
                                    : "You"
                                }
                            </span>
                            <button
                                onClick={() => setReplyMessageData('')}
                                className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                            >
                                <X className="w-4 h-4" />
                            </button>
                        </div>

                        <p className="text-sm text-gray-800 mt-1 w-full line-clamp-2">
                            {replyMessageData?.text || "No message content"}
                        </p>
                    </div>
                </div>
            )}
        </Fragment>
    );
}

export default memo(UserChat);